function GridBoxV2Item({ box }) {
    if (!box) return null;

    return (
        <div className="relative w-full h-full text-white group overflow-hidden">
            <img src={box.image} alt={box.alt} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-black/70" />

            <div className="absolute top-1/2 -translate-y-1/2 left-0 w-full h-full flex items-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <div className="flex flex-col items-start text-start gap-2 p-10">
                    <h3 className="font-bold text-2xl panoragraf-light uppercase text-mcare">{box.tag}</h3>
                    <p className="text-lg text-balance">{box.description}</p>
                </div>
            </div>
        </div>
    );
}

function GridBoxV2MobileItem({ box }) {
    if (!box) return null;

    return (
        <div className="relative w-full h-56 text-white overflow-hidden">
            <img src={box.image} alt={box.alt} className="w-full h-full object-cover" />
           <div className="absolute inset-0 bg-black/70" />

            <div className="absolute bottom-0 left-0 w-full flex flex-col items-start gap-2 p-6">
                <h3 className="font-bold text-xl panoragraf-light uppercase text-mcare">{box.tag}</h3>
                <p className="text-base font-semibold text-balance">{box.description}</p>
            </div>
        </div>
    );
}

export default function GridBoxV2({ boxes = [] }) {
    return (
        <>
            {/* Desktop version */}
            <section className="hidden md:flex h-screen">
                <div className="w-2/3">
                    <div className="h-1/2">
                       {/* TOP LEFT IMAGE */}
                       <GridBoxV2Item box={boxes[0]} />
                    </div>
                    <div className="h-1/2 flex">
                        {/* BOTTOM HALF */}
                        <div className="w-1/3">
                            {/* LEFT IMAGE */}
                            <GridBoxV2Item box={boxes[2]} />
                        </div>
                        <div className="w-2/3">
                            {/* RIGHT IMAGE */}
                            <GridBoxV2Item box={boxes[3]} />
                        </div>
                    </div>

                </div>
                <div className="w-1/3">
                    {/* RIGHT IMAGE */}
                    <GridBoxV2Item box={boxes[1]} />
                </div>
            </section>

            {/* Mobile version */}
            <div className="flex md:hidden flex-col">
                {boxes.map((box, index) => (
                    <GridBoxV2MobileItem key={index} box={box} />
                ))}
            </div>
        </>
    );
}
